import { render, staticRenderFns } from "./EditCreateCoverDialog.vue?vue&type=template&id=0d4236d0&scoped=true&"
import script from "./EditCreateCoverDialog.vue?vue&type=script&lang=js&"
export * from "./EditCreateCoverDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditCreateCoverDialog.vue?vue&type=style&index=0&id=0d4236d0&prod&scoped=true&lang=css&"
import style1 from "./EditCreateCoverDialog.vue?vue&type=style&index=1&id=0d4236d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4236d0",
  null
  
)

export default component.exports